import forgotPasswordActions from '../actionTypes/forgotPasswordActions';

const initialState = {
  isSubmitting: false,
  openModal: false,
};


const forgotPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case forgotPasswordActions.forgotPassword:
      return { ...state, isSubmitting: true };
    case forgotPasswordActions.forgotPasswordSuccess:
      return { ...state, isSubmitting: false, openModal: false };
    case forgotPasswordActions.forgotPasswordFailed:
      return { ...state, isSubmitting: false };
    case forgotPasswordActions.toggleModal:
      return { ...state, openModal: !state.openModal };
    default:
      return state;
  }
};

export default forgotPasswordReducer;
